// 📂 components/Forms/Input/TableInputField.tsx
import React from "react";
import RequiredAsteriskTooltip from "./RequiredAsteriskTooltip";

interface TableInputFieldProps {
  label?: string;
  name?: string;
  type?: "text" | "number" | "email" | "password" | "date";
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

const TableInputField: React.FC<TableInputFieldProps> = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  error,
  placeholder,
  disabled,
  required,
  className = "",
}) => {
  const baseClasses =
    "w-full px-3 py-2 text-sm text-gray-900 dark:text-white outline-none transition bg-transparent focus:border-primary focus:ring-0";
  const borderClasses =
    "rounded border border-stroke dark:border-form-strokedark focus-within:border-primary";

  return (
    <div className={`flex flex-col ${className}`}>
      {/* 🔹 Etiqueta opcional */}
      {label && (
        <label
          htmlFor={name}
          className="mb-1 flex items-center gap-1 text-xs font-medium text-gray-700 dark:text-gray-300"
        >
          {label}
          {required && <RequiredAsteriskTooltip delay={400} />}
        </label>
      )}

      {/* 🔹 Contenedor input */}
      <div className={`${borderClasses}`}>
        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`${baseClasses} ${
            disabled ? "cursor-not-allowed opacity-70" : ""
          }`}
        />
      </div>

      {/* 🔹 Mensaje de error */}
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default TableInputField;
